import axios from 'axios';
import {
    ElMessage
} from 'element-plus';

const service = axios.create({
    // baseURL: '/api',
    baseURL: '/api/',
    timeout: 1000 * 60 * 10,
});

service.interceptors.request.use(

    
    (config) => {
        return config;
    },
    (error) => {
        return Promise.reject();
    }
);

service.interceptors.response.use(
    (response) => {
        if (response.status === 200) {
            if (response.config.responseType == "blob") {
                return response.data;
            }
            if (response.data.code === 400) {

            } else {
                if (response.data.code === 200 || response.data.resultCode === '01' || response.data.access_token || response.data.success + '' === 'true') {

                    return response.data;
                } else {
                    ElMessage.warning(response.data.resultMessage)

                    return Promise.reject()
                }
            }
        } else {
            ElMessage.warning(response.data.resultMessage)

            return Promise.reject();
        }
    },
    (error) => {
        if (error.code === 'ECONNABORTED') {
            ElMessage.warning('请求超时')
        } else {
            if (error.request.responseType == "blob") {
                let fileReader = new FileReader()
                fileReader.readAsText(error.response.data, 'utf-8')
                fileReader.onload = function () {
                    const result = JSON.parse(fileReader.result)
                    // ElMessage.warning(result.msg)
                    ElMessage.warning('功能开发中，敬请期待！')

                }
            }

            if (error.response.data.msg) {
                if (error.request.responseURL.indexOf('/ca-share-document/document/endpoint/preview') > -1) {
                    ElMessage.warning('功能开发中，敬请期待！')
                } else {
                    ElMessage.warning(error.response.data.msg)

                }

            }

        }
        return Promise.reject(error)


    }
);

export default service;